<template>
  <svg class="svg-icon" :style="sizeStyle" aria-hidden="true">
    <use :xlink:href="symbolId" />
  </svg>
</template>

<script lang="ts">
  import { defineComponent, computed } from 'vue'
  export default defineComponent({
    name: 'SvgIcon',
    props: {
      prefix: {
        type: String,
        default: 'icon',
      },
      name: {
        type: String,
        required: true,
      },
      // 为数字时单位为px
      size: {
        type: [String, Number],
        default: '1em',
      },
    },
    setup(props) {
      const symbolId = computed(() => `#${props.prefix}-${props.name}`)
      const sizeStyle = computed(() => {
        const { size } = props
        const sizeVal = typeof size === 'number' ? `${size}px` : size
        return {
          width: sizeVal,
          height: sizeVal,
        }
      })
      return {
        symbolId,
        sizeStyle,
      }
    },
  })
</script>

<style scoped lang="less">
  .svg-icon {
    display: inline-block;
    width: 1em;
    height: 1em;
    vertical-align: -0.15em;
    fill: currentColor;
    overflow: hidden;
  }
</style>
